module.exports = __webpack_public_path__ + "img/one_12.a1a7ccb5.png";